
export function cookie(name , value , options ) {
  if (value) { // name and value given, set cookie
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    let expires = '';
    if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
      let date;
      if (typeof options.expires === 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    const path = options.path ? '; path=' + options.path : '';
    const domain = options.domain ? '; domain=' + options.domain : '';
    const secure = options.secure ? '; secure' : '';
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
  } else { // only name given, get cookie
    let cookieValue = '';
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      // tslint:disable-next-line:no-shadowed-variable
      for (const cookie of cookies) {
        if (cookie.trim().substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.trim().substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  } 
}

/**
 * 短信按钮恢复倒计时
 * @param {按钮} button 
 * @param {禁止时间} time 
 */
export function disableSmsButton(button,time){

  button.innerHTML = '已发送('+time+')'
  button.disabled = true
  let timer = setInterval(()=>{
    time = time - 1 
    // console.log(time)
    button.innerHTML = '已发送('+time+')'
    if(time <= 0 ){
      clearInterval(timer)
      button.innerHTML = '重新发送短信'
      button.disabled = false
    }
  },1000)
  
}


// WEBPACK FOOTER //
// ./src/utils/util.js